<template>
  <div class="signup-container">
    <!-- Conditional rendering based on the current step -->
    <div v-if="currentStep === 1">
      <StepOne @next="nextStep" />
    </div>
    <div v-if="currentStep === 2">
      <StepTwo @next="nextStep" @prev="prevStep" :found-itinerary="foundItinerary" />
    </div>
    <div v-if="currentStep === 3">
      <StepThree @prev="prevStep" :found-itinerary="foundItinerary" :current-listing="currentListing"/>
    </div>
  </div>
</template>

<script>
import StepOne from '../newPostingViews/StepOne.vue';
import StepTwo from '../newPostingViews/StepTwo.vue';
import StepThree from '../newPostingViews/StepThree.vue';

export default {
  components: {
    StepOne,
    StepTwo,
    StepThree
  },
  data() {
    return {
      currentStep: 1,  // Start at the first step
      foundItinerary: null,
      currentListing: null,
    };
  },
  computed: {
    progressStyle() {
      // Calculate the progress percentage based on the current step
      const progress = (this.currentStep / 3) * 100;
      return { width: `${progress}%` };
    }
  },
  methods: {
    nextStep(dataFromChild) {
      if (this.currentStep === 1 && dataFromChild) {
        this.foundItinerary = dataFromChild;
      }

      if (this.currentStep === 2 && dataFromChild) {
        this.currentListing = dataFromChild;
      }

      if (this.currentStep < 3) {
        this.currentStep++;
      }
    },
    prevStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    }
  }
};
</script>

<style scoped>
.signup-container {
  width: 100%;
  margin: auto;
  padding: 0px;
  /* No scroll overflow here */
}

.progress-bar {
  height: 10px;
  background-color: #f0f0f0;
  border-radius: 5px;
  margin-bottom: 20px;
  overflow: hidden;
  width: 100%;
}

.progress {
  height: 100%;
  background-color: #4caf50;
  transition: width 0.3s ease;
}

button {
  margin-top: 20px;
}
</style>
